export default "__VITE_ASSET__kGfCJPXK__"